import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.switch.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'UPPER_RIGHT', label: '右上' },
        ],
    },
    blue: {
        rectColour: CATEGORIES.switch.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

defineBlock({
    type: 'fader',
    colour: CATEGORIES.switch.color,
    textColour: '#FFFFFF',
    tooltip: 'フェーダーの位置を指定した範囲の値で読み取ります',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/fader.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('フェーダー', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: 'を' },
            ],
        },
        {
            kind: 'value',
            name: 'MIN_VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('～', { fontSize: 13, fontWeight: 'medium' }),
                },
            ],
        },
        {
            kind: 'value',
            name: 'MAX_VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 100 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'で検知する ' }],
        },
    ],
    onBoardChange: (block, board) => {
        const field = block.getField('POSITION') as FieldOperatorDropdown | null;
        if (!field) return;
        field.setOptions([...POSITION_OPTIONS[board].options]);
    },
});
